/**
 * Module-level (not a hook ref) because the sim card unmounts on pause/navigation
 * and the request outlives it. Deliberately NOT wired to unmount or `setScenario`:
 * a backgrounded/tabbed-away learner's audio must keep running.
 */
const controllers = new Map<number, AbortController>();

/** Returns an `abort` handle so the turn's own audio-timeout timer can cancel the request it owns. */
export const registerTurnAbort = (turnId: number) => {
	const controller = new AbortController();
	controllers.set(turnId, controller);
	return { signal: controller.signal, abort: () => controller.abort() };
};

export const releaseTurnAbort = (turnId: number) => {
	controllers.delete(turnId);
};

/** Aborts every in-flight turn request. Idempotent. */
export const abortPendingAudio = () => {
	for (const controller of controllers.values()) {
		controller.abort();
	}
	controllers.clear();
};
